<template>
    <div class="ziliao">
        <Header :index="'zlaoti'" style="position:fixed;top:0"></Header>
        <div class="x-tab">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane v-for="(i,index) in timeList" :label="i.scheDescriptoin" :name="i.scheDescriptoin"
                             :key="index">
                    <div class="cardHeader">
                        <i @click="$router.go(-1)" class="el-icon-arrow-left"></i><span>{{$route.query.name}}</span>
                    </div>
                    <div class="card" v-for="l in i.myScheduleList">
                        <div class="card-border-top"></div>
                        <img class="img-content" :src="l.logo" alt="">
                        <div class="text-content">
                            <h2>{{l.scheduleName}}</h2>
                            <p><span>演讲嘉宾： </span><span v-for="k in l.guestList">{{k.name }} </span></p>
                            <p class="space-between">
                                <span>演讲时长： {{l.schedulePayTime}}</span><span>观看时间： {{l.scheduleTime}}</span>
                            </p>
                            <p class="moreTwo">
                                <span>内容简介： </span>{{l.summary}}
                            </p>
                            <div class="card-botton">
                                <el-button v-if="l.scheduleState == 3" type="primary" round>直播回放</el-button>
                                <el-button v-if="l.scheduleState == 2" type="primary" round>观看</el-button>
                                <el-button v-if="l.scheduleState == 1" type="primary" round>未开始</el-button>
                                <div class="collect" @click="addCollect(l)">
                                    <img class="collect-img" :src="l.followed == '1'?logoActive:logo">
                                    <span class="collect-text"
                                          :style="l.followed == '1'?'color:rgba(34,113,255,1);':'color:rgba(98,98,98,1);'">收藏</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import {callApi} from "../api/callApi";
    import {apiMethod} from "../global/config";

    export default {
        components: {
            Footer,
            Header
        },
        data() {
            return {
                logo: require("../assets/imgs/shoucang2.png"),
                logoActive: require("../assets/imgs/shoucang (1).png"),
                activeName: "first",
                show: true,
                cardList: '',
                timeList: '',
            };
        },
        methods: {
            addCollect(val) {
              console.log(val.followed)
                if (val.followed != '1') {
                    callApi(apiMethod.SET_MY_FOLLOW, {
                        targetId: val.id,
                        targetType: 0
                    }).then(response => {
                        this.search()
                    })
                }else{
                  callApi(apiMethod.SET_BACK_MY_FOLLOW, {
                    targetId: val.id,
                    targetType: 0
                  }).then(response => {
                    this.search()
                  })
                }
            },
            handleClick(tab, event) {
                // console.log(tab, event);
            },
            search() {
                callApi(apiMethod.GET_STUDY_VIDEO_GROUP_DETAIL, {id: this.$route.query.id * 1,timeZone:0}).then(response => {
                    let res = response.data;
                    this.timeList = res
                    this.activeName = this.timeList[0].scheDescriptoin
                });

            },
        },
        created() {
            this.search()
        },
    };
</script>
<style lang="less" scoped>
    .space-between {
        display: flex;
        justify-content: space-between;
    }

    .cardHeader {
        padding: 15px 0 15px 30px;
        background: url('../assets/imgs/bjtx.png') no-repeat;
        background-size: cover;
        color: rgba(255, 255, 255, 1);
        font-size: 15px;
        box-sizing: border-box;

        i {
            margin-right: 18px;
            cursor: pointer;
        }
    }

    .card {
        border: 1px solid rgba(169, 196, 242, 1);
        border-bottom: none;
        position: relative;
        padding: 15px 30px 15px 30px;
        display: flex;

        &:last-child {
            border-bottom: 1px solid rgba(169, 196, 242, 1);
        }

        .card-border-top {
            width: 491px;
            height: 2px;
            background: rgba(34, 113, 255, 1);
            position: absolute;
            top: -1px;
            left: 0;
        }

        .img-content {
            width: 474px;
            height: 240px;
            margin-right: 59px;
            flex: 0 0 474px;
        }

        .text-content {
            position: relative;
            flex: 1;

            .time {
                margin: 28px 0 18px 0;

                img {
                    height: 26px;
                    width: 26px;
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 13px;
                }

                span {
                    vertical-align: middle;
                    font-size: 25px;
                    line-height: 25px;
                    display: inline-block;
                    color: rgba(34, 113, 255, 1);
                }
            }

            h2 {
                font-size: 18px;
                color: #222222;
                /*margin-top: 13px;*/
                line-height: 30px;
            }

            p {
                color: #626262;
                font-size: 15px;
                margin-top: 16px;
            }

            .ph {
                color: rgba(98, 98, 98, 1);
                font-weight: 300;
                margin-top: 13px;
            }

            .moreTwo {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .card-botton {
                margin-top: 29px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%;

                .el-button {
                    width: 250px;
                    height: 53px;
                    background: rgba(34, 113, 255, 1);
                    border-radius: 32px;
                    font-size: 15px;
                    box-shadow: none;
                }

                .collect {
                    cursor: pointer;
                    margin-right: 22px;

                    img {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 12px;
                    }

                    span {
                        vertical-align: middle;
                        font-size: 15px;
                        line-height: 15px;
                        display: inline-block;
                    }
                }
            }
        }
    }

    .ziliao {
        padding-top: 100px;
        overflow: auto;

        .x-tab {
            width: 1080px;
            height: 100%;
            margin: 40px auto;

            .video-list {
                width: 1080px;
                height: 100%;
                margin: 46px 0;

                .v-desc {
                    width: 1080px;
                    height: 348px;
                    position: relative;
                    margin-bottom: 64px;

                    .v-left {
                        width: 498px;
                        height: 348px;
                        display: inline-block;
                        margin-top: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .v-center {
                        width: 685px;
                        height: 299px;
                        background-color: #fff;
                        display: inline-block;
                        margin-top: -250px;
                        margin-left: 381px;
                        transform: translateY(-75px);
                        display: flex;
                        justify-content: space-between;

                        .top {
                            // width: 158px;
                            margin-left: 45px;

                            h3 {
                                color: #212121;
                                font-size: 20px;
                                margin-top: 28px;
                            }

                            p {
                                width: 529px;
                            }

                            .forum {
                                color: #626262;
                                margin-top: 25px;
                                font-size: 14px;
                            }

                            .msg {
                                color: #9c9c9c;
                                font-size: 12px;
                                padding: 15px 0;
                                line-height: 30px;
                            }
                        }

                        .right {
                            width: 50px;
                            height: 299px;
                            background: rgba(219, 232, 254, 1);

                            i {
                                line-height: 299px;
                                margin-left: 15px;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
</style>